import React from 'react';
import get from 'lodash/get';
import { cutStringToNCharacters } from 'core/utils/helpers/string';
import { addCommas } from 'core/utils/helpers/numbers';
import ProductDetailsLink from 'core/modules/ProductDetailsLink/ProductDetailsLink';
import ProductOverlayLink from 'core/modules/ProductOverlayLink/ProductOverlayLink';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import PremierMerchantRebate from 'core/modules/PremierMerchantRebate/PremierMerchantRebate';
import orgConfig from 'org/configs/org.config';

import './ProductItem.scss';

function ProductItem({
  product, rebateOptions, extraLabel,
}) {
  const {
    id, images, name, price, merchantName, merchantRebates, rebate,
    hasTiered, merchantCount, clickUrl, onSale, isExtraRewards: isExtraRewardsProduct,
  } = product;
  const hasMultipleMerchant = merchantCount > 1;
  const productImage = get(images, '[0]');
  const shouldShowExtraLabel = rebate?.isExtraRewards || isExtraRewardsProduct;
  const { extraRewardsName } = orgConfig;

  const formatRebates = () => {
    const rebates = merchantRebates.split('-');
    const lowRebate = rebates[0] || '';
    const highRebate = rebates[1] || lowRebate;

    const formattedRebate = addCommas(highRebate);

    const shouldShowTieredLanguage = (hasMultipleMerchant && lowRebate !== highRebate) || hasTiered;

    return shouldShowTieredLanguage ? `Earn up to ${formattedRebate}` : `Earn ${formattedRebate}`;
  };

  const formattedRebate = merchantRebates ? formatRebates() : '';

  const renderProductItem = () => (
    <div className="mn_productItemWrap">
      <div className="mn_productLogoWrap">
        <img className="mn_productLogo" src={productImage} alt={name} />
      </div>
      <div className="mn_productInfo">
        <p className="mn_name" dangerouslySetInnerHTML={{ __html: cutStringToNCharacters(name, 61) }} />
        <p className="mn_price">{price}</p>
        { hasMultipleMerchant ?
          <p className="mn_rebate">{formattedRebate}</p> :
          <PremierMerchantRebate {...rebate} showRebateInline {...rebateOptions} />
        }
      </div>
      <div className="mn_merchant">
        {hasMultipleMerchant
          ? <p className="mn_compareMerchant">Compare at {merchantCount} stores</p>
          : <p className="mn_soldByMerchant">Sold by {merchantName}</p>
        }
      </div>
      {shouldShowExtraLabel && <div className="mn_extraFlag">{extraLabel || extraRewardsName}</div>}
      {!shouldShowExtraLabel && onSale && <div className="mn_saleFlag">Sale</div>}
    </div>
  );

  return hasMultipleMerchant ? (
    <ProductOverlayLink productId={id}>
      { renderProductItem() }
    </ProductOverlayLink>
  ) : (
    <ProductDetailsLink id={id} useClickUrl clickUrl={clickUrl} name={name}>
      { renderProductItem() }
    </ProductDetailsLink>
  );
}

export default (props) => <ComponentErrorBoundary><ProductItem {...props} /></ComponentErrorBoundary>;
